var render = function render(_c,_vm){return _c('contract-info',{attrs:{"info":_vm.props.row}})
}
var staticRenderFns = []

export { render, staticRenderFns }